import { gql } from '@apollo/client';

export const DTOOLS_AUTH_DETAILS_FRAGMENT = gql`
  fragment DtoolsAuthDetails on DtoolsAuthDetails {
    id
    partnerId
    maskedApiKey
  }
`;

export const DTOOLS_PROJECT_IMPORT_DETAILS = gql`
  fragment DtoolsProjectImportDetails on ExternalProjectImportPreview {
    id
    address
    addressId
    projectName
    created {
      name
      entity
    }
    updated {
      name
      entity
      diffs {
        field
        newValue
        oldValue
      }
    }
  }
`;
